import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";
import Header from "./components/Header/Header";
import Error404 from "./components/Error404";

import logoUsados from "./assets/images/marcas/usados.png";
import logoFiat from "./assets/images/marcas/fiat.png";
import logoFord from "./assets/images/marcas/ford.png";
import logoJeep from "./assets/images/marcas/jeep.png";
import logoPeugeot from "./assets/images/marcas/peugeot.png";
import logoRentauto from "./assets/images/marcas/rentauto.png";
import logoQuicklane from "./assets/images/marcas/quicklane.png";
import { useEffect, useState } from "react";

function App() {
  const [OSName, setOSname] = useState(null);
  const [linkFordPass, setLinkFordPass] = useState(null);

  useEffect(() => {
    if (window.navigator.userAgent.indexOf("Android") !== -1) {
      setOSname("Android");
      setLinkFordPass("https://wk.ar/bO1");
    }

    if (window.navigator.userAgent.indexOf("Mac") !== -1) {
      setOSname("Mac");
      setLinkFordPass("https://wk.ar/nOj");
    }
  }, []);

  const listado = [
    {
      key: "ford",
      marca: "Ford",
      logo: logoFord,
      botones: [
        {
          title: "Consultá por tu 0km",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=00",
        },
        {
          title: "Consultá por Plan Óvalo",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Posventa",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Servicio Técnico - Turnos",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Sucursales",
          link: "https://montironiford.com/contacto/",
        },
        {
          title: "Nuestros modelos",
          link: "https://marketing.montironi.com/ford/todos",
        },
        {
          title: "Descarga Ford Pass",
          link: linkFordPass,
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#1700F4",
          link: "https://www.facebook.com/MontironiFord",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#1700F4",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
    {
      key: "fiat",
      marca: "Fiat",
      logo: logoFiat,
      botones: [
        {
          title: "Consultá por tu 0km",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Consultá por Fiat Plan",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Repuestos & Accesorios",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Servicio Técnico - Turnos",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Sucursales",
          link: "https://www.montironifiat.com.ar/contacto/",
        },
        {
          title: "Nuestros modelos",
          link: "https://marketing.montironi.com/fiat/todos",
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#E42A39",
          link: "https://www.facebook.com/MontironiFiat",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#E42A39",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
    {
      key: "jeep",
      marca: "Jeep",
      logo: logoJeep,
      botones: [
        {
          title: "Consultá por tu 0km",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Repuestos & Accesorios",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Servicio Técnico - Turnos",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Sucursales",
          link: "https://montironijeep.com/contacto/",
        },
        {
          title: "Nuestros modelos",
          link: "https://marketing.montironi.com/montironi-jeep/todos",
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#000",
          link: "https://www.facebook.com/MontironiJeep",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#000",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
    {
      key: "peugeot",
      marca: "Peugeot",
      logo: logoPeugeot,
      botones: [
        {
          title: "Consultá por tu 0km",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Repuestos & Accesorios",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Servicio Técnico - Turnos",
          link: "https://api.whatsapp.com/send/?phone=5493516825130&text&type=phone_number&app_absent=0",
        },
        {
          title: "Sucursales",
          link: "https://montironipeugeot.com.ar/contacto/#mapa",
        },
        {
          title: "Nuestros modelos",
          link: "https://marketing.montironi.com/peugeot/todos",
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#00A3E0",
          link: "https://www.facebook.com/MontironiPeugeot",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#00A3E0",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
    {
      key: "rentauto",
      marca: "Rentauto",
      logo: logoRentauto,
      botones: [
        {
          title: "Reservá Online",
          link: " https://rentautoargentina.com.ar/index.php",
        },
        {
          title: "Consultá por Whatsapp | Córdoba",
          link: "https://api.whatsapp.com/send?phone=5493517915738",
          size: 15,
        },
        {
          title: "Consultá por Whatsapp | Mendoza",
          link: "https://api.whatsapp.com/send?phone=542615890262",
          size: 15,
        },
        {
          title: "Flota disponible",
          link: "https://rentautoargentina.com.ar/flota.php",
        },
        {
          title: "Servicio para empresas",
          link: "https://rentautoargentina.com.ar/para-empresas.php",
        },
        {
          title: "Cómo llegar | Córdoba",
          link: "https://www.rentautoargentina.com.ar/sucursal-cordoba.php",
        },
        {
          title: "Cómo llegar | Mendoza",
          link: "https://www.rentautoargentina.com.ar/sucursal-mendoza.php",
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#E76000",
          link: "https://www.facebook.com/rentautoargentina",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#E76000",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
    {
      key: "usados",
      marca: "Usados",
      logo: logoUsados,
      botones: [
        {
          title: "Consultá por whatsapp",
          link: "https://api.whatsapp.com/send?phone=+5493517915736&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n",
        },
        {
          title: "Cotizá tu vehículo",
          link: "https://montironiusados.com/vender",
        },
        {
          title: "Vehículos disponibles",
          link: "https://montironiusados.com/",
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#39a935",
          link: "https://www.facebook.com/montironiusados",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#39a935",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
    {
      key: "quicklane",
      marca: "Quicklane",
      logo: logoQuicklane,
      botones: [
        {
          title: "Consultá por whatsapp",
          link: "https://api.whatsapp.com/send?phone=5493513519097&text=Quiero%20consultar%20por%20los%20servicios%20que%20he%20visto%20en%20su%20p%C3%A1gina%20web",
        },
        {
          title: "Cómo llegar",
          link: "https://quicklanecordoba.com/contacto/",
        },
        {
          title: "Nuestros Servicios",
          link: "https://quicklanecordoba.com/servicios/",
        },
        {
          title: "Facebook",
          link: "https://www.facebook.com/QLMontironi",
        },
        {
          title: "Linkedin",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
      social: [
        {
          title: "Facebook",
          icon: "fb",
          color: "#F8971D",
          link: "https://www.facebook.com/QLMontironi",
        },
        {
          title: "Linkedin",
          icon: "in",
          color: "#F8971D",
          link: "https://www.linkedin.com/company/montironi/mycompany/",
        },
      ],
    },
  ];

  return (
    <Router basename="/linktree">
      <Switch>
        <Route exact path="/usados">
          <Header marca={"usados"} listado={listado} title={"Encontrá lo que necesitás"} />
        </Route>

        <Route exact path="/ford">
          <Header marca={"ford"} listado={listado} title={"Encontrá lo que necesitás"} />
        </Route>

        <Route exact path="/fiat">
          <Header marca={"fiat"} listado={listado} />
        </Route>

        <Route exact path="/jeep">
          <Header marca={"jeep"} listado={listado} />
        </Route>

        <Route exact path="/peugeot">
          <Header marca={"peugeot"} listado={listado} title={"Encontrá lo que necesitás"} />
        </Route>

        <Route exact path="/quicklane">
          <Header marca={"quicklane"} listado={listado} title={"Encontrá lo que necesitás"} />
        </Route>

        <Route exact path="/rentauto">
          <Header marca={"rentauto"} listado={listado} title={"Encontrá lo que necesitás"} />
        </Route>

        <Route path="*">
          <Header bg="bgDark" />
          <Error404 />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;

